import React from "react";
import {Redirect} from "react-router-dom";


import Login from "./components/home/Login";
//import Home from "./components/home/Home";
// 首页
import HomePage from './components/homePage';
import PerformanceRank from "./components/home/performanceRank";
import PerformanceDetail from "./components/home/performanceDetail";
import SsuPerformanceRank from "./components/home/ssuPerformanceRank";
import SsuPerformanceDetail from "./components/home/ssuPerformanceDetail";
import PmPerformanceRank from "./components/home/pmPerformanceRank";
import PmPerformanceDetail from "./components/home/pmPerformanceDetail";
import LeaderPerformanceRank from "./components/home/leaderPerformanceRank";
import LeaderPerformanceDetail from "./components/home/leaderPerformanceDetail";
import TeamRecommendTalentRank from "./components/home/teamRecommendTalentRank";
import TeachingRank from "./components/home/TeachingRank";
import TeachingDetail from "./components/home/TeachingDetail";
// 临床项目
import InvestigationList from "./components/investigation/InvestigationList";
import SiteList from "./components/investigation/SiteList";
import InvestigationView from "./components/investigation/InvestigationView";
// 工时管理
import MonthlyFTE from "./components/manHour/monthlyFte";
import MyWeekly from "./components/manHour/MyWeekly";
import MyWeeklys from "./components/manHour/MyWeeklys";
import MyEfficiency from "./components/manHour/MyEfficiency";
import Query from "./components/manHour/query";
import Confirm from "./components/manHour/confirmManhour";
import ManHourWrite from "./components/manHour/writeManhour";
import Hour from "./components/manHour/hour";
import Report from "./components/manHour/Report";
import UnconfirmProManhour from "./components/manHour/unconfirmProManhour";
// 项目计划
import DegreePlan from "./components/plan/Degree";
import InvStart from "./components/plan/invStart";
import PlanSiteStart from "./components/plan/siteStart";
import InvestigationPlan from "./components/plan/Investigation";
import SitePlan from "./components/plan/Site";
// 研究中心
import ResearchCenterDetail from "./components/site/researchCenterDetail";
import PIInfo from "./components/site/piInfo";
import CRA from "./components/site/CRA";
import ResearchCenterCost from "./components/site/researchCenterCost";
// 项目成员
import CrcInfo from "./components/member/crcInfo";
import Distribution from "./components/member/Distribution";
import StaffEfficiency from "./components/member/staffEfficiency";
// 项目执行
import VisitPeriodPlan from "./components/executeMgr/visitPeriodPlan";
import VisitPeriodPlanHandle from "./components/executeMgr/visitPeriodPlan/VisitPeriodPlanHandle";
import ExecuteMgrCrf from "./components/executeMgr/Crf";
import Violation from "./components/executeMgr/Violation";
import ImportantEvent from './components/execute/importantEvent';
import StandardVisitNum from './components/execute/standardVisitNum';
import ExecuteMgrQA from "./components/executeMgr/QA";
import ExecuteMgrTemplate from "./components/executeMgr/template";
import Crf from "./components/execute/Crf";
import ManHour from "./components/execute/manHour";
import Patients from "./components/execute/Patients";
import QA from "./components/execute/QA";
import Template from "./components/execute/template";
// 项目状态
import Charts from "./components/summary/inGroup";
import ChartsVisit from "./components/summary/finishVisit";
import GroupingRate from "./components/summary/inGroupRate";
import ChartsSiteFilter from "./components/summary/siteCondition";
import SiteGroupingRate from "./components/summary/siteInGroupRate";
import SummarySiteStart from "./components/summary/siteStart";
import ChartsFTE from "./components/summary/ChartsFTE";
import ChartsSiteFTE from "./components/summary/ChartsSiteFTE";
import ChartsPreFilter from "./components/summary/ChartsPreFilter";
import ChartsFilter from "./components/summary/Filter";
import SumViolation from "./components/summary/Violation";
import GroupingRateCompare from "./components/summary/GroupingRateCompare";
// 医院科室
import HospitalInfo from "./components/hospital/hospitalInfo";
import DepartmentInfo from "./components/hospital/departmentInfo";
import CommentInfo from "./components/hospital/commentInfo";
import DoctorInfo from "./components/hospital/doctorInfo";
import SsuLog from "./components/hospital/ssuLog";
import Ssu from "./components/hospital/ssu";
import Staffing from "./components/hospital/Staffing";
import StaffScore from "./components/hospital/StaffScore";
import WorkFlowHospital from './components/hospital/WorkFlowHospital';
// 项目汇总
import WeeklySummary from "./components/sumTotal/weeklySummary";
import MonthlySummary from "./components/sumTotal/monthlySummary";
import CRCWeekly from "./components/sumTotal/crcWeekly";
import Efficiency from "./components/sumTotal/Efficiency";
import CrcQuarterScore from "./components/sumTotal/crcQuarterScore";
// 人员管理
import UserInfo from "./components/user/userInfo";
import UserResume from "./components/user/UserResume";
import UserVitae from "./components/user/curriculumVitae";
import UserGenerateVitae from "./components/user/generateCurriculumVitae";
import UserPlan from "./components/user/userPlan";
import UserEfficiency from "./components/user/userEfficiency";
import UserOutput from "./components/user/output";
import UserAnalysis from "./components/user/UserAnalysis";
import AreaCityAnalysis from "./components/user/areaCityAnalysis";
import DashedReport from "./components/user/DashedReport";
import UserManhour from "./components/user/manHour";
import PmInfo from "./components/user/pmInfo";
import FieldLeader from "./components/user/fieldLeader";
import CrcTeamContributeScore from './components/user/crcTeamContributeScore';
import TeamManageEvaluate from './components/user/teamManageEvaluate';
import Require from "./components/user/require";
import Transfer from "./components/user/transfer";
import RMTransfer from "./components/user/transfer/RMTransfer";
import UserDimission from "./components/user/userDimission";
import CrcPostRank from "./components/user/crcPostRank";

// 质量管理
import QualityImportantEvent from './components/execute/importantEvent';
import ComplaintRegistrationForm from './components/qualityManagement/ComplaintRegistrationForm';
import Nationalverification from './components/qualityManagement/Nationalverification';
import ImportantMilestone from './components/qualityManagement/ImportantMilestone';
// 项目汇总
import ProjectPercent from "./components/sumTotal/projectPercent";
import ProPercent from "./components/investigation/ProPercent";
// 项目合同
import MainContract from "./components/projectContract/mainContract";
import ChildContract from "./components/projectContract/childContract";
import ContractRecord from "./components/projectContract/contractRecord";
import CostOfContractSplit from "./components/projectContract/costOfContractSplit";
import ProTerminationApply from "./components/projectContract/terminationApply";
// 项目计划
import SiteFte from "./components/plan/siteFte";
import PmFte from "./components/plan/PmFte";
// 研究中心推荐
import ResearchCenterRecommend from "./components/siteComment/researchCenterRecommend";
// 合同管理
import ContractManagement from "./components/contractManagement/contractRecord";
import CrmContractRecord from "./components/contractManagement/crmContractRecord";
import RequestRecord from "./components/contractManagement/requestRecord";
import CoFollowFunds from "./components/contractManagement/coFollowFunds";
import ReturnedMoney from "./components/contractManagement/returnedMoney";
import IdentificationCode from "./components/contractManagement/IdentificationCode";
import ApplyJdeCode from "./components/contractManagement/ApplyJdeCode";
import ContractInfoChange from './components/contractManagement/contractInfoChange';
import AlterJdeCode from "./components/contractManagement/alterJdeCode";
import TerminationApply from "./components/contractManagement/terminationApply";
import CurrencyExchangeRate from "./components/contractManagement/currencyExchangeRate";
import ResponseCustomer from "./components/contractManagement/responseCustomer";
import BaGrouping from "./components/contractManagement/baGrouping";
import CrcAgreeReportSummary from "./components/contractManagement/crcAgreeReportSummary";
import Activityitem from "./components/activityitem";
// 财务管理
import FinanceIncomeReport from "./components/financeManagement/financeIncomeReport";
import OtherChargesReport from "./components/financeManagement/otherChargesReport";
import OrderChangeReport from "./components/financeManagement/orderChangeReport";
import FinancialAnomalyReport from "./components/financeManagement/financialAnomalyReport";
import CenterIncomeReport from "./components/financeManagement/centerIncomeReport";
import CollectReport from "./components/financeManagement/collectReport";
import IncomeReport from "./components/financeManagement/IncomeReport";
import Incomestatement from "./components/financeManagement/incomestatement";

// 项目启动
import Heredity from "./components/invStartUp/heredity";
import SiteStart from "./components/invStartUp/siteStart";
import StartUpWorkFlow from "./components/invStartUp/workFlow";
import StartUpSiteForm from "./components/invStartUp/siteForm";
// 项目关闭
import SiteClose from "./components/invShutOff/siteClose";
import ShutOffWorkFlow from "./components/invShutOff/workFlow";
import ShutOffSiteForm from "./components/invShutOff/siteForm";
// 竞争公司
import CompeteCompanyPerformance from './components/competeCompany/Performance';
import CompeteCompanyCompare from './components/competeCompany/Compare';
import CompeteCompanyEnrollment from './components/competeCompany/Enrollment';
// 项目报价
import Quotation from './components/quotation/list';
import QuotationPro from './components/quotation/Production';
// 导航
import Information from "./components/personal/information";
import CurriculumVitae from "./components/personal/curriculumVitae";
import GenerateCurriculumVitae from "./components/personal/generateCurriculumVitae";
import NoticeSetting from "./components/personal/setting";
import Notice from "./components/layout/notice";
import Setting from "./components/layout/Setting";
import DownloadSite from "./components/layout/DownloadSite";
// 带教管理
import Director from "./components/teachingManagement/director";
import Management from "./components/teachingManagement/management";
import QualityAssessmentSheet from "./components/teachingManagement/qualityAssessmentSheet";
import ClinicalEvaluationRecord from "./components/clinicalEvaluation/clinicalEvaluationRecord";
import VisitAssess from "./components/clinicalEvaluation/clinicalEvaluationRecord/VisitAssess";
import StandardVisitPrice from "./components/clinicalEvaluation/standardVisitPrice";
import FTEAssess from "./components/clinicalEvaluation/clinicalEvaluationRecord/FTEAssess";
import ViewPage from "./components/clinicalEvaluation/clinicalEvaluationRecord/components/ViewPage";
import VisitQuotation from "./components/clinicalEvaluation/clinicalEvaluationRecord/VisitQuotation";
import PTReimburse from "./components/contractManagement/ptReimburse";
import StandardVisitHourCompare from "./components/summary/StandardVisitHourCompare";
import VisitingHours from "./components/clinicalEvaluation/visitingHours";
import BusinessOfferRecord from "./components/businessOffer/businessOfferRecord";
import TaskUnitPrice from "./components/businessOffer/taskUnitPrice";
import SiteStartServiceFeePercent from "./components/businessOffer/siteStartServiceFeePercent";
import BusinessVisitingHours from "./components/businessOffer/visitingHours";
import File from "./components/personal/file";
import UserFolder from "./components/user/UserFolder";
import ProjectFile from "./components/fileManagement/projectFile";
import DockingData from "./components/clinicalEvaluation/clinicalEvaluationRecord/DockingData";
import FteQuotation from "./components/clinicalEvaluation/clinicalEvaluationRecord/FteQuotation";
import FilingInfo from "./components/hospital/filingInfo";
import DepartmentalDocuments from "./components/documentManagement/departmentalDocuments";

const routes = [{
    path: '/',
    breadcrumbName: '首页/',
    exact: true,
    // render: () => 1 ? <Redirect to="/home"/> : <Redirect to="/login"/>,
    render: () => <Redirect to="/home"/>,
}, {
    path: '/home',
    exact: true,
    breadcrumbName: '首页/',
    render: (props) => <HomePage {...props} />,
}, {
    path: '/home/:pageType',
    exact: true,
    breadcrumbName: '首页/',
    render: (props) => <HomePage {...props} />,
}, 

// {
//     path: '/homePage',
//     exact: true,
//     render: () => <HomePage />,
// },

{
    path: '/notice',
    exact: true,
    breadcrumbName: '通知/',
    render: () => <Notice />,
}, {
    path: '/setting',
    exact: true,
    breadcrumbName: '设置/',
    render: () => <Setting />,
}, {
    path: '/downloadSite',
    exact: true,
    breadcrumbName: '下载站/',
    render: () => <DownloadSite />,
}, {
    path: '/login',
    exact: true,
    breadcrumbName: '登录/',
    render: () => <Login />,
}, {
    path: '/permission-403',
    exact: true,
    render: () => <Login />,
}, {
    path: '/invList/:invId',
    exact: true,
    render: (props) => <InvestigationList {...props}/>,
}, {
    path: '/invList',
    exact: true,
    render: () => <InvestigationList />,
}, {
    path: '/siteList/:selRole/:selInvId',
    exact: true,
    render: (props) => <SiteList {...props}/>,
}, {
    path: '/invDetails',
    exact: true,
    render: () => <InvestigationView />,
}, {
    path: '/plan/degree',
    exact: true,
    render: () => <DegreePlan />,
}, {
    path: '/plan/invStart',
    exact: true,
    render: () => <InvStart />,
}, {
    path: '/plan/siteStart',
    exact: true,
    render: () => <PlanSiteStart />,
}, {
    path: '/plan/investigation', ///:statisticalType
    exact: true,
    render: (props) => <InvestigationPlan {...props} />,
}, {
    path: '/plan/site', ///:statisticalType
    exact: true,
    render: (props) => <SitePlan {...props} />,
}, {
    path: '/site/detail',
    exact: true,
    render: (props) => <ResearchCenterDetail {...props} />,
}, {
    path: '/site/pi',
    exact: true,
    render: () => <PIInfo />,
}, {
    path: '/site/cra',
    exact: true,
    render: () => <CRA />,
}, {
    path: '/site/researchCenterCost',
    exact: true,
    render: () => <ResearchCenterCost />,
}, {
    path: '/member/crc',
    exact: true,
    render: () => <CrcInfo />,
}, {
    path: '/member/require',
    exact: true,
    render: () => <Require src='Member' />,
}, {
    path: '/member/require/:requireId',
    exact: true,
    render: (props) => <Require src='Member' {...props}/>,
},  {
    path: '/member/distribution',
    exact: true,
    render: () => <Distribution />,
}, {
    path: '/executeMgr/visitPeriodPlan',
    exact: true,
    render: (props) => <VisitPeriodPlan {...props} />,
}, {
    path: '/executeMgr/visitPeriodPlanHandle',
    exact: true,
    render: (props) => <VisitPeriodPlanHandle {...props} />,
},{
    path: '/executeMgr/crf/:typeName',
    exact: true,
    render: (props) => <ExecuteMgrCrf {...props} />,
}, {
    path: '/executeMgr/Violation',
    exact: true,
    render: (props) => <Violation {...props} />,
}, {
    path: '/executeMgr/qa',
    exact: true,
    render: () => <ExecuteMgrQA />,
}, {
    path: '/executeMgr/template/:type',
    exact: true,
    render: (props) => <ExecuteMgrTemplate {...props} />,
}, {
    path: '/execute/visitPeriodPlan',
    exact: true,
    render: (props) => <VisitPeriodPlan {...props} />,
}, {
    path: '/execute/manHour',
    exact: true,
    render: () => <ManHour />,
}, {
    path: '/execute/manHour/:relateId',
    exact: true,
    render: (props) => <ManHour {...props} />,
}, {
    path: '/execute/patients',
    exact: true,
    render: () => <Patients />,
}, {
    path: '/execute/standardVisitNum',
    exact: true,
    render: () => <StandardVisitNum />,
}, {
    path: '/execute/crf/:typeName',
    exact: true,
    render: (props) => <Crf {...props}/>,
}, {
    path: '/execute/crf/:typeName/:patientId',
    exact: true,
    render: (props) => <Crf {...props}/>,
}, {
    path: '/execute/importantEvent',
    exact: true,
    render: () => <ImportantEvent />,
}, {
    path: '/execute/qa',
    exact: true,
    render: () => <QA />,
}, {
    path: '/execute/transfer',
    exact: true,
    render: (props) => <Transfer {...props} src="Execute" />,
}, {
    path: '/execute/transfer/:handoverId',
    exact: true,
    render: (props) => <Transfer {...props} src="Execute" />,
}, {
    path: '/execute/template/:type',
    exact: true,
    render: (props) => <Template {...props} />,
}, {
    path: '/hospital/detail',
    exact: true,
    render: () => <HospitalInfo />,
}, {
    path: '/hospital/departmentDetail',
    exact: true,
    render: () => <DepartmentInfo />,
}, {
    path: '/hospital/commentInfo',
    exact: true,
    render: () => <CommentInfo />,
}, {
    path: '/hospital/doctor',
    exact: true,
    render: () => <DoctorInfo />,
}, {
    path: '/hospital/filingInfo',
    exact: true,
    render: () => <FilingInfo />,
}, {
    path: '/SsuLog',
    exact: true,
    render: () => <SsuLog/>,
}, {
    path: '/hospital/ssu',
    exact: true,
    render: () => <Ssu />,
}, {
    path: '/hospital/WorkFlow',
    exact: true,
    render: () => <WorkFlowHospital />,
}, {
    path: '/hospital/staffing',
    exact: true,
    render: () => <Staffing />,
}, {
    path: '/hospital/staffScore',
    exact: true,
    render: () => <StaffScore />,
}, {
    path: '/manHour/write',
    exact: true,
    render: () => <ManHourWrite />,
}, {
    path: '/manHour/myHour',
    exact: true,
    render: (props) => <Hour {...props} />,
},{
    path: '/manHour/myHour/:investigation/:relateId',
    exact: true,
    render: (props) => <Hour {...props} />,
},{
    path: '/manHour/write/:manHourId/:date',
    exact: true,
    render: (props) => <ManHourWrite {...props}/>,
}, {
    path: '/manHour/monthlyFTE',
    exact: true,
    render: () => <MonthlyFTE />,
}, {
    path: '/manHour/myWeekly',
    exact: true,
    render: () => <MyWeekly />,
}, {
    path: '/manHour/myWeeklys/:name',
    exact: true,
    render: (props) => <MyWeeklys {...props} />,
}, {
    path: '/manHour/myEfficiency',
    exact: true,
    render: () => <MyEfficiency />,
}, {
    path: '/manHour/query',
    exact: true,
    render: () => <Query />,
}, {
    path: '/manHour/confirm',
    exact: true,
    render: (props) => <Confirm {...props} />,
}, {
    path: '/manHour/confirm/:investigation/:relateId',
    exact: true,
    render: (props) => <Confirm {...props} />,
}, {
    path: '/manHour/monthlyFTE/:name',
    exact: true,
    render: (props) => <MonthlyFTE {...props}/>,
}, {
    path: '/manHour/report',
    exact: true,
    render: (props) => <Report/>,
}, {
    path: '/manHour/unconfirmProManhour',
    exact: true,
    render: (props) => <UnconfirmProManhour />,
}, {
    path: '/summary/visit/:name',
    exact: true,
    render: (props) => <ChartsVisit {...props} />,
}, {
    path: '/summary/preFilter/:name',
    exact: true,
    render: (props) => <ChartsPreFilter {...props} />,
}, {
    path: '/summary/filter',
    exact: true,
    render: () => <ChartsFilter />,
}, {
    path: '/summary/violation',
    exact: true,
    render: () => <SumViolation />,
}, {
    path: '/summary/site/:name',
    exact: true,
    render: (props) => <ChartsSiteFilter {...props} />,
}, {
    path: '/summary/siteFTE',
    exact: true,
    render: () => <ChartsSiteFTE />,
},{
    path: '/summary/fte/:name',
    exact: true,
    render: (props) => <ChartsFTE {...props} />,
}, {
    path: '/summary/view/:name',
    exact: true,
    render: (props) => <Charts {...props} />,
}, {
    path: '/summary/siteStart/:name',
    exact: true,
    render: (props) => <SummarySiteStart {...props} />,
}, {
    path: '/summary/groupingRate',
    exact: true,
    render: () => <GroupingRate />,
}, {
    path: '/summary/groupingRateCompare',
    exact: true,
    render: () => <GroupingRateCompare />,
}, {
    path: '/summary/siteGroupingRate',
    exact: true,
    render: () => <SiteGroupingRate />,
}, {
    path: '/summary/standardVisitHourCompare',
    exact: true,
    render: () => <StandardVisitHourCompare />,
}, {
    path: '/sumTotal/weeklySummary',
    exact: true,
    render: () => <WeeklySummary />,
},{
    path: '/sumTotal/efficiency',
    exact: true,
    render: () => <Efficiency />,
},{
    path: '/user/userInfo',
    exact: true,
    render: () => <UserInfo />,
},{
    path: '/user/userResume',
    exact: true,
    render: () => <UserResume />,
}, {
    path: '/user/userFolder',
    exact: true,
    render: () => <UserFolder />,
}, {
    path: '/user/curriculumVitae',
    exact: true,
    render: () => <UserVitae />,
}, {
    path: '/user/generateCurriculumVitae',
    exact: true,
    render: () => <UserGenerateVitae />,
},{
    path: '/user/userPlan',
    exact: true,
    render: () => <UserPlan />,
},{
    path: '/user/require',
    exact: true,
    render: () => <Require src='User'/>,
},{
    path: '/user/require/:requireId',
    exact: true,
    render: (props) => <Require src='User' {...props}/>,
},{
    path: '/user/userEfficiency',
    exact: true,
    render: () => <UserEfficiency/>,
},{
    path: '/user/UserOutput',
    exact: true,
    render: () => <UserOutput/>,
},{
    path: '/user/UserDistribution',
    exact: true,
    render: () => <Distribution src="UserManage" />,
},{
    path: '/user/transfer/:handoverId',
    exact: true,
    render: (props) => <Transfer src="User" {...props}/>,
},{
    path: '/user/transfer',
    exact: true,
    render: (props) => <Transfer src="User" {...props}/>,
},{
    path: '/user/pmTransfer',
    exact: true,
    render: (props) => <RMTransfer src="pmTransfer" {...props}/>,
},{
    path: '/user/userDimission',
    exact: true,
    render: () => <UserDimission />,
},{
    path: '/user/crcPostRank',
    exact: true,
    render: () => <CrcPostRank />,
},{
    path: '/user/UserAnalysis',
    exact: true,
    render: () => <UserAnalysis/>,
},{
    path: '/user/areaCityAnalysis',
    exact: true,
    render: () => <AreaCityAnalysis />,
},{
    path: '/qualityManagement/importantEvent',
    exact: true,
    render: () => <QualityImportantEvent />,
},{
    path: '/qualityManagement/complaintRegistrationForm',
    exact: true,
    render: () => <ComplaintRegistrationForm />,
},{
    path: '/qualityManagement/nationalVerification',
    exact: true,
    render: () => <Nationalverification />,
},{
    path: '/qualityManagement/ImportantMilestone',
    exact: true,
    render: () => <ImportantMilestone />,
},{
    path: '/sumTotal/percent',
    exact: true,
    render: () => <ProjectPercent />,
},{
    path: '/proPercent',
    exact: true,
    render: () => <ProPercent/>,
},{
    path: '/projectContract/mainContract',
    exact: true,
    render: () => <MainContract />,
},{
    path: '/projectContract/childContract',
    exact: true,
    render: () => <ChildContract />,
},{
    path: '/projectContract/contractRecord',
    exact: true,
    render: () => <ContractRecord />,
},{
    path: '/projectContract/requestRecord',
    exact: true,
    render: () => <RequestRecord />,
},
// {
//     path: '/projectContract/coFollowFunds',
//     exact: true,
//     render: () => <CoFollowFunds />,
// },
{
    path: '/projectContract/returnedMoney',
    exact: true,
    render: () => <ReturnedMoney />,
},{
    path: '/projectContract/applyJdeCode',
    exact: true,
    render: () => <ApplyJdeCode />,
},{
    path: '/projectContract/contractInfoChange',
    exact: true,
    render: () => <ContractInfoChange />,
},{
    path: '/projectContract/alterJdeCode',
    exact: true,
    render: () => <AlterJdeCode />,
},{
    path: '/projectContract/costOfContractSplit',
    exact: true,
    render: () => <CostOfContractSplit />,
},{
    path: '/projectContract/terminationApply',
    exact: true,
    render: () => <ProTerminationApply />,
},{
    path:'/sumTotal/monthlySummary',
    exact:true,
    render: () => <MonthlySummary />,
},{
    path:'/sumTotal/crcWeekly',
    exact:true,
    render:()=><CRCWeekly />,
},{
    path:'/plan/siteFte',
    exact:true,
    render:()=><SiteFte />,
},{
    path:'/user/DashedReport',
    exact:true,
    render:()=><DashedReport />,
},{
    path:'/user/userManhour',
    exact:true,
    render:()=><UserManhour />,
},{
    path: '/user/pmInfo',
    exact: true,
    render: () => <PmInfo />,
},{
    path: '/user/fieldLeader',
    exact: true,
    render: () => <FieldLeader />,
},{
    path: '/user/crcTeamContributeScore',
    exact: true,
    render: () => <CrcTeamContributeScore />,
},{
    path: '/user/teamManageEvaluate',
    exact: true,
    render: () => <TeamManageEvaluate />,
},{
    path:'/plan/PmFte',
    exact:true,
    render:()=><PmFte role="PM" />,
},{
    path:'/plan/PAFte',
    exact:true,
    render:()=><PmFte role="PA" />,
},{
    path: '/member/staffEfficiency',
    exact: true,
    render: () => <StaffEfficiency/>,
},{
    path: '/siteComment',
    exact: true,
    render: () => <ResearchCenterRecommend />,
},{
    path: '/contractManagement/contractRecord',
    exact: true,
    render: () => <ContractManagement/>,
},{
    path: '/contractManagement/crmContractRecord',
    exact: true,
    render: () => <CrmContractRecord/>,
},{
    path: '/contractManagement/requestRecord',
    exact: true,
    render: () => <RequestRecord />,
},{
    path: '/contractManagement/coFollowFunds',
    exact: true,
    render: () => <CoFollowFunds/>,
},{
    path: '/contractManagement/returnedMoney',
    exact: true,
    render: () => <ReturnedMoney/>,
},{
    path: '/contractManagement/IdentificationCode',
    exact: true,
    render: () => <IdentificationCode/>,
},{
    path: '/contractManagement/applyJdeCode',
    exact: true,
    render: () => <ApplyJdeCode />,
},{
    path: '/contractManagement/applyJdeCode/:jdeApplyCode',
    exact: true,
    render: (props) => <ApplyJdeCode {...props}/>,
},{
    path: '/contractManagement/contractInfoChange',
    exact: true,
    render: () => <ContractInfoChange />,
},{
    path: '/contractManagement/alterJdeCode',
    exact: true,
    render: () => <AlterJdeCode />,
},{
    path: '/contractManagement/terminationApply',
    exact: true,
    render: () => <TerminationApply />,
},{
    path: '/contractManagement/currencyExchangeRate',
    exact: true,
    render: () => <CurrencyExchangeRate />,
},{
    path: '/contractManagement/responseCustomer',
    exact: true,
    render: () => <ResponseCustomer />,
},{
    path: '/contractManagement/baGrouping',
    exact: true,
    render: () => <BaGrouping />,
},{
    path: '/contractManagement/crcAgreeReportSummary',
    exact: true,
    render: () => <CrcAgreeReportSummary />,
},{
    path: '/contractManagement/activityitem',
    exact: true,
    render: () => <Activityitem />,
},{
    path: '/contractManagement/ptReimburse',
    exact: true,
    render: () => <PTReimburse />,
},{
    path: '/startUp/heredity',
    exact: true,
    render: () => <Heredity />,
},{
    path: '/financeManagement/financeIncomeReport',
    exact: true,
    render: () => <FinanceIncomeReport />,
},{
    path: '/financeManagement/incomestatement',
    exact: true,
    render: () => <Incomestatement />,
},{
    path: '/financeManagement/otherChargesReport',
    exact: true,
    render: () => <OtherChargesReport />,
},{
    path: '/financeManagement/orderChangeReport',
    exact: true,
    render: () => <OrderChangeReport />,
},{
    path: '/financeManagement/financialAnomalyReport',
    exact: true,
    render: () => <FinancialAnomalyReport />,
},{
    path: '/financeManagement/centerIncomeReport',
    exact: true,
    render: () => <CenterIncomeReport />,
},{
    path: '/financeManagement/collectReport',
    exact: true,
    render: () => <CollectReport />,
},{
    path: '/financeManagement/IncomeReport',
    exact: true,
    render: () => <IncomeReport />,
},{
    path: '/startUp/siteStart',
    exact: true,
    render: (props) => <SiteStart {...props} />,
},{
    path: '/startUp/workFlow',
    exact: true,
    render: () => <StartUpWorkFlow />,
},{
    path: '/startUp/siteForm',
    exact: true,
    render: () => <StartUpSiteForm />,
},{
    path: '/shutOff/siteClose',
    exact: true,
    render: () => <SiteClose />,
},{
    path: '/shutOff/workFlow',
    exact: true,
    render: () => <ShutOffWorkFlow />,
},{
    path: '/shutOff/siteForm',
    exact: true,
    render: () => <ShutOffSiteForm />,
},{
    path: '/performanceRank/:date',
    exact: true,
    render: (props) => <PerformanceRank {...props} />,
},{
    path: '/performanceDetail',
    exact: true,
    render: () => <PerformanceDetail />,
},{
    path: '/ssuPerformanceRank/:date',
    exact: true,
    render: (props) => <SsuPerformanceRank {...props} />,
},{
    path: '/ssuPerformanceDetail',
    exact: true,
    render: () => <SsuPerformanceDetail />,
},{
    path: '/pmPerformanceRank/:date',
    exact: true,
    render: (props) => <PmPerformanceRank {...props} />,
},{
    path: '/pmPerformanceDetail',
    exact: true,
    render: () => <PmPerformanceDetail />,
},{
    path: '/leaderPerformanceRank/:date',
    exact: true,
    render: (props) => <LeaderPerformanceRank {...props} />,
},{
    path: '/teamRecommendTalentRank/:date',
    exact: true,
    render: (props) => <TeamRecommendTalentRank {...props} />,
},{
    path: '/teachingRank/:date',
    exact: true,
    render: (props) => <TeachingRank {...props} />,
},{
    path: '/teachingDetail',
    exact: true,
    render: (props) => <TeachingDetail {...props} />,
},{
    path: '/leaderPerformanceDetail',
    exact: true,
    render: () => <LeaderPerformanceDetail />,
},{
    path: '/competeCompany/performance',
    exact: true,
    render: () => <CompeteCompanyPerformance />,
},{
    path: '/competeCompany/compare',
    exact: true,
    render: () => <CompeteCompanyCompare />,
}, {
    path: '/competeCompany/enrollment',
    exact: true,
    render: () => <CompeteCompanyEnrollment />,
}, {
    path: '/sumTotal/crcQuarterScore',
    exact: true,
    render: () => <CrcQuarterScore />
}, {
    path: '/personal/information',
    exact: true,
    render: () => <Information />
}, {
    path: '/personal/curriculumVitae',
    exact: true,
    render: () => <CurriculumVitae />
}, {
    path: '/personal/generateCurriculumVitae',
    exact: true,
    render: () => <GenerateCurriculumVitae />
}, {
    path: '/personal/setting',
    exact: true,
    render: () => <NoticeSetting />
}, {
    path: '/personal/file',
    exact: true,
    render: () => <File />
}, {
    path: '/fileManagement/projectFile',
    exact: true,
    render: () => <ProjectFile />
}, {
    path: '/quotation/list',
    exact: true,
    render: () => <Quotation />
}, {
    path: '/quotation/production',
    exact: true,
    render: () => <QuotationPro />
}, {
    path: '/teaching/director',
    exact: true,
    render: () => <Director />
}, {
    path: '/teaching/management',
    exact: true,
    render: () => <Management />
}, {
    path: '/teaching/qualityAssessmentSheet',
    exact: true,
    render: () => <QualityAssessmentSheet />
}, {
    path: '/clinicalEvaluation/clinicalEvaluationRecord',
    exact: true,
    render: () => <ClinicalEvaluationRecord />
}, {
    path: '/clinicalEvaluation/visitAssess/:evaluateRecordId',
    exact: true,
    render: (props) => <VisitAssess {...props}/>
}, {
    path: '/clinicalEvaluation/FTEAssess/:evaluateRecordId',
    exact: true,
    render: (props) => <FTEAssess {...props}/>
}, {
    path: '/clinicalEvaluation/visitQuotation/:evaluateRecordId',
    exact: true,
    render: (props) => <VisitQuotation {...props}/>
}, {
    path: '/clinicalEvaluation/fteQuotation/:evaluateRecordId',
    exact: true,
    render: (props) => <FteQuotation {...props}/>
}, {
    path: '/clinicalEvaluation/standardVisitPrice',
    exact: true,
    render: () => <StandardVisitPrice />
}, {
    path: '/clinicalEvaluation/ViewPage',
    exact: true,
    render: () => <ViewPage />
}, {
    path: '/clinicalEvaluation/VisitingHours',
    exact: true,
    render: () => <VisitingHours />
}, {
    path: '/clinicalEvaluation/DockingData',
    exact: true,
    render: () => <DockingData />
}, {
    path: '/businessOffer/businessOfferRecord',
    exact: true,
    render: () => <BusinessOfferRecord />
}, {
    path: '/businessOffer/taskUnitPrice',
    exact: true,
    render: () => <TaskUnitPrice />
}, {
    path: '/businessOffer/siteStartServiceFeePercent',
    exact: true,
    render: () => <SiteStartServiceFeePercent />
}, {
    path: '/businessOffer/businessVisitingHours',
    exact: true,
    render: () => <BusinessVisitingHours />
}, {
    path: '/documentManagement/departmentalDocuments',
    exact: true,
    render: () => <DepartmentalDocuments />
}];

export default routes;


// WEBPACK FOOTER //
// ./src/router.js